module.exports = __webpack_public_path__ + "static/media/auditorium-ah.58f4ce1f.jpg";